import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['C'] as const;

const validator = AbstractMeasurement.value
    .extend({
        unit: z.literal('C').default('C'),
    })
    .default({});

export const ChargeCapacity = {
    validator,
    units,
};

export type ChargeCapacity = z.infer<typeof validator>;
